<template lang="pug">
#footnotes
  ol.pt-5
    li#footnote1.mb-5 Para una revisión a la metodología y definiciones empleadas para obtener esta información consultar: González, Denise y Jorge Ruiz (et.al.). Violencia y terror. Hallazgos sobre fosas clandestinas en México (2019). Versión electrónica, disponible en: &nbsp;
      a.accent-color.bold(href="https://ibero.mx/files/2019/violencia-y-terror.pdf" target="_blank") https://ibero.mx/files/2019/violencia-y-terror.pdf
      a.accent-color.bold(href="#anchor1") ↩︎
    li#footnote2.mb-5 Entendemos una fosa clandestina como: sitio donde uno o más cuerpos y/o restos de personas fueron enterrados o semienterrados, de forma anónima y/o ilegal, en el intento de ocultar o destruir evidencia, y que posteriormente fueron exhumados por particulares o autoridades. Ibíd.
      a.accent-color.bold(href="#anchor2") ↩︎
    li#footnote3.mb-5 Queremos hacer énfasis en que los datos que presentaremos de esta fuente no necesariamente están reflejando los patrones de hallazgos de fosas y de desaparición de personas en la entidad. Lo que estos datos están reportando es el proceso sobre cómo se produce/observa socialmente esta información, así como los posibles sesgos que tienen. Algunos de estos sesgos pueden ser: 1) capacidades institucionales para registrar los datos; 2) capacidad de abarcar determinadas áreas geográficas y; 3) factores políticos y sociales que permitan que un hallazgo se reporte o no, entre otros.
      a.accent-color.bold(href="#anchor3") ↩︎
    li#footnote4.mb-5 Lo que es importante tomar en cuenta es que pudieron haber hallazgos de fosas en estos municipios, sin embargo la prensa no tuvo capacidad de registrarlos/observarlos, por lo que se dejan los datos como NA y no como cero.
      a.accent-color.bold(href="#anchor4") ↩︎
    li#footnote5.mb-5 Para una explicación detallada sobre cómo funciona el modelo de predicción consultar: Mónica, Meltis (et.al.). New results for the identification of clandestine graves in Mexico (2017), página electrónica, disponible en:&nbsp;
      a.accent-color.bold(href="https://hrdag.org/2017/11/23/new-clandestine-graves-mexico/" target="_blank") https://hrdag.org/2017/11/23/new-clandestine-graves-mexico/
      span &nbsp;y Ball, Patrick (et.al.). Predicting the location of hidden graves in Mexico using machine learning models (2019). Conferencia, disponible en:&nbsp;
      a.accent-color.bold(href="https://www.youtube.com/watch?v=MheYVAEBXhw&list=PLY1zaOaaYKDts3Ww72naSEinbCVCPONnT&index=17" target="_blank") https://www.youtube.com/watch?v=MheYVA
      a.accent-color.bold(href="#anchor5") ↩︎
    li#footnote6.mb-5 Sabemos que los municipios que registran la prensa y las fiscalías estatales no siempre son los mismos, además de que tienen características geográficas, sociodemográficas y de violencia distintas. Por esta razón es importante presentar las predicciones con base en ambas fuentes dentro de nuestros mapas.
      a.accent-color.bold(href="#anchor6") ↩︎
    li#footnote7.mb-5 Los resultados están establecidos con puntajes entre 0 y 1. Con base en nuestro modelo, mientras más cercano al uno sea el resultado, mayor es la probabilidad de que ese municipio tenga una fosa clandestina. Por ejemplo, un municipio con un puntaje de 0.75 tendría un 75% de probabilidad de contar con al menos una fosa clandestina.
      a.accent-color.bold(href="#anchor7") ↩︎
  p.bold.my-0 Autores
  p.my-0
    span.medium Jorge Ruiz Reyes&nbsp;
    span - Programa de Derechos Humanos de la Universidad Iberoamericana CDMX
  p.my-0
    span.medium Fabrizio Lorusso&nbsp;
    span - Investigador de la Universidad Iberoamericana León, Guanajuato
  p.mb-5
    span.medium Oscar Elton&nbsp;
    span - Data Cívica

  a.default-color.italic.underline.bold(href="/assets/docs/Resumen Ejecutivo.pdf" target="_blank") Descarga aquí el resumen ejecutivo

</template>

<script>
export default {
  name: "footnotes"
};
</script>

<style lang="scss">
#footnotes {
  padding: 0 3rem;
}

//small devices
@media (max-width: 420px) {
  #footnotes {
    padding: 0;
  }
}
</style>
